import React from "react";
import "./About.css";
import Textbox from "./Textbox"

const Club = () => {

  return (
    <>
    <div className="home">
      <div className="home__container">
            <Textbox heading="Leksaksbilar.se" 
            text="Vi är stolta över att vara officiella affiliate-partners med Leksaksbilar.se, Sveriges ledande butik för leksaksbilar och modellbilar.

Leksaksbilar.se erbjuder:
• Över 4000 produkter från världens bästa märken
• Hot Wheels, LEGO, Siku, Majorette, Maisto och många fler
• RC-bilar, modellbilar och leksaksbilar för alla åldrar
• Snabb leverans över hela Sverige
• Professionell kundservice och support
• Säker betalning med alla vanliga betalningsmetoder

Genom vårt samarbete kan vi erbjuda dig tillgång till deras kompletta sortiment till konkurrenskraftiga priser." />

            <Textbox heading="Adtraction Affiliate" 
                        text="Vårt samarbete med Leksaksbilar.se sker genom Adtraction, Nordens ledande affiliate-nätverk.

Adtraction garanterar:
• Säker och transparent affiliate-hantering
• Korrekt spårning av alla klick och köp
• Professionell rapportering och statistik
• Snabb utbetalning av provisioner
• Teknisk support och optimering
• GDPR-kompatibel datahantering

Detta säkerställer att vårt samarbete fungerar smidigt och att du som kund får den bästa möjliga upplevelsen." />

            <Textbox heading="Bli partner" 
                        text="Vill du också bli en del av vårt nätverk? Vi välkomnar andra som delar vår passion för leksaksbilar och modellbilar.

Möjligheter för partners:
• Affiliate-samarbete med Leksaksbilar.se
• Cross-promotion av relaterade produkter
• Gemensamma marknadsföringskampanjer
• Delning av resurser och kunskap
• Utveckling av nya samarbetsformer

Kontakta oss på info@isaksbilar.se för att diskutera möjliga samarbeten. Vi är alltid intresserade av att träffa likasinnade som delar vår vision om att göra leksaksbilar tillgängliga för alla barn." />

      </div>
    </div>
</>
  );
};

export default Club;
